<div class="registration-form-card registration-success-card">
  <h1 class="form-title">Confirm Your Account</h1>
  <p class="form-subtitle">
    Please follow the steps below to verify and log in to your account.
  </p>

  <ul class="confirmation-steps">
    <li class="confirmation-step">
      <div class="step-icon" >
        <div class="step-illustration">
          <img src="/utest-static/assets/images/registration/confirm-email.svg" alt=""/>
        </div>
      </div>
      <div class="step-content">
        <span class="step-title">1. Check your inbox for an email with your verification link</span>
      </div>
    </li>

    <li class="confirmation-step">
      <div class="step-icon">
        <div class="step-illustration">
          <img src="/utest-static/assets/images/registration/setup-password.svg" alt=""/>
        </div>
      </div>
      <div class="step-content">
        <span class="step-title">2. Set up your password for your uTest account</span>
      </div>
    </li>

    <li class="confirmation-step" >
      <div class="step-icon">
        <div class="step-illustration">
          <img src="/utest-static/assets/images/registration/login.svg" alt="" />
        </div>
      </div>
      <div class="step-content">
        <span class="step-title">{{ isCustomRegistration ? '3. Log in to uTest to get started' : '3. Log in to utest.com to start your testing journey'}}</span>
      </div>
    </li>
  </ul>

  <!-- Custom Registration Application Notice -->
  @if (isCustomRegistration && customRegistration) {
    <div class="custom-registration-notice">
      <h2 class="notice-title">Then, Complete Your Application</h2>
      <p class="notice-subtitle">
        After confirming your account, you will be able to apply to more projects.
      </p>
      <div class="application-card">
        <div class="application-icon">
          <img src="/utest-static/assets/images/icons/book-edit.svg" alt="" />
        </div>
        <div class="application-content">
          <p class="application-label">APPLY TO THE PROJECT</p>
          <h3 class="application-project-name">{{ customRegistration.title }}</h3>
        </div>
        <a class="continue-button" [href]="embeddedFormUrl">
          Continue To Application
          <img src="/utest-static/assets/images/icons/chevron-right.svg" alt="" aria-hidden="true" />
        </a>
      </div>
    </div>
  }

  <div class="help-section">
    <p class="help-text">
      Having issues or need help? Contact us at <a href="https://support.utest.com/csp" target="_blank"
    rel="noopener noreferrer" class="help-link">support.utest.com</a>
  </p>
</div>
</div>
